module.exports = __webpack_public_path__ + "img/bf.3268425e.svg";